import { Component, OnInit } from '@angular/core';
import { HeadersFacade } from '../../../domain/facades/facades';
import { vendor_branch_inteface } from '../../../domain/entites/HeaderThemes.model';
import { CheckOutFacades } from 'imakeapp-checkout';

@Component({
  selector: 'app-branches-modal',
  templateUrl: './branches-modal.component.html',
  styleUrls: ['./branches-modal.component.scss']
})
export class BranchesModalComponent implements OnInit {


  show_dialog_box: boolean = true;
  vendor_branches?: vendor_branch_inteface[];
  active_branch: any;


  constructor(
    private header_facades: HeadersFacade,private checkOutFacades:CheckOutFacades
  ) { }

  ngOnInit(): void
  {

    this.request_states();
    this.listen_to_display_status();

  }




  request_states()
  {

    // requesting vendor branches
    this.header_facades.request_vendor_branches();


  }


  listen_to_display_status()
  {

    this.header_facades.branches_modal_state$.subscribe(
      (state)=>{
        this.show_dialog_box = state.show;
      }
    );


    this.header_facades.vendor_branches_state$.subscribe(
      (state)=>{

        // this is to handle error returning a string
        typeof state == 'string' ? this.vendor_branches = [] : this.vendor_branches = state;

      }
    );


    this.header_facades.active_branch_selector$.subscribe(
      (state)=>{
        this.active_branch = state;

      }
    );


  }


  close_auth_modal()
  {
    this.header_facades.show_branches_modal(false);
  }

  branch_selected_handler(branch: vendor_branch_inteface)
  {

    this.header_facades.set_active_branch(branch);
    this.header_facades.show_branches_modal(false);
    this.checkOutFacades.selectBranchForCheckout(branch.branchId!!)
  }



}
